import React, { useState } from 'react';
import {Link} from 'gatsby';
import {Spring} from 'react-spring/renderprops';
import isExternalLink from '../../util/isExternalLink';
import Caret from '../../assets/icons/chevron_right.svg';
import {Trans, useTranslation} from 'react-i18next';
import Close from "../../assets/icons/close-menu.svg";
import AccountButton from "../AccountButton/AccountButton";
import LanguageSwitcher from '../LanguageSwitcher';
import {ScrollContext} from '../../util/ScrollContext';

const OffCanvas = React.memo(({links, onClose, language, urls}) => {

    const {t} = useTranslation();
    const [closeMenuOnBlur, setCloseMenuOnBlur] = useState(false);

    return (<section className="off-canvas">
        <div className="scroll-content">
            <nav aria-labelledby="label-canvas-menu" className="canvas-menu-wrapper">
                <Spring
                    duration={50}
                    delay={400}
                    from={{opacity: 0}}
                    to={{opacity: 1}}
                >
                    {props => (<div style={props}>
                        <div>
                            <div className="canvas-menu-header">
                                <AccountButton text={t('navigation.my_digid')} url={t('my_digid_url')}/>
                            </div>
                            <h3 id="label-canvas-menu" className="sr-only">Hoofdnavigatie</h3>
                            <ul className="canvas-menu">
                                <li>
                                    <Link to={t('home_url')} activeClassName="current"
                                        onClick={onClose}><Caret/> Home</Link>
                                </li>
                                {links && links.map(link => (<li key={link.url.path}>
                                    {isExternalLink(link.url.path) ?
                                        <a href={link.url.path}><Caret/> {link.label}</a> :
                                        <Link to={link.url.path} activeClassName="current" partiallyActive
                                            onClick={onClose}><Caret/> {link.label}</Link>}
                                </li>))}
                            </ul>
                            <h3 id="label-language-switcher-mobile" className="sr-only">Website taal veranderen</h3>
                            <LanguageSwitcher language={language} urls={urls}
                                clickCallback={() => sessionStorage.setItem('digid-hamburger-open', true)}/>
                        </div>
                        <ScrollContext.Consumer>
                            {({toggleMenu}) => (
                                <button className="menu-toggle" onClick={() => {
                                    onClose(false);
                                    toggleMenu(false);
                                }}
                                onKeyDown={(e) => {
                                    const shouldBlur = e.key === 'Tab' && !e.shiftKey
                                    setCloseMenuOnBlur(shouldBlur)
                                }}
                                onBlur={(e) => {
                                    if (closeMenuOnBlur) {
                                        onClose(false);
                                        toggleMenu(false);
                                    }
                                }} >
                                    <span className="menu-close"><Trans i18nKey="navigation.close">Sluit</Trans>
                                        <Close/>
                                    </span>
                                </button>
                            )}
                        </ScrollContext.Consumer>
                    </div>
                    )}
                </Spring>
            </nav>
        </div>
    </section>);
});

export default OffCanvas;
